import { writable } from 'svelte/store';
import posthog from 'posthog-js';
import { browser } from '$app/environment';

export const flags = writable({});

function refreshFlags() {
    flags.set({
        double_referral_rewards: posthog.isFeatureEnabled('double_referral_rewards'),
        // free_shipping: posthog.isFeatureEnabled('free_shipping'),
    });
    console.log({ flags });
}

if (browser) {
    posthog.onFeatureFlags(refreshFlags);
    refreshFlags();
}